<template>
  <BaseModal
    class="unlimited-intro-modal app-container"
    :full-screen="isMobile"
    flush-content
    ui-refresh
    @close-modal-clicked="handleClose">
    <template #body>
      <div class="layout-container d-flex flex-column align-items-center p-md">
        <UnlimitedIntro/>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-center w-100">
        <BaseButton
          text="Got it!"
          class="w-100"
          @click="handleGetStarted"/>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/global/BaseModal.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import UnlimitedIntro from '@/components/onboarding/UnlimitedIntro.vue'
import useScreenSize from '@shared/composables/screenSize.js'
import { useOnboardingStore } from '@/stores/onboarding.js'
import { useHideIntercomLauncher } from '@shared/composables/intercom.js'
import { onBeforeUnmount, onMounted } from 'vue'
import { useRouter } from 'vue-router'

useHideIntercomLauncher()
const { isMobile } = useScreenSize()
const router = useRouter()

const onboardingStore = useOnboardingStore()
const {
  trackUnlimitedIntro,
  completeUnlimitedIntro
} = onboardingStore

onMounted(() => {
  trackUnlimitedIntro('open')
})

onBeforeUnmount(() => {
  trackUnlimitedIntro('dismiss')
})

function handleClose() {
  trackUnlimitedIntro('click', { button: 'close' })
  completeUnlimitedIntro()
}

function handleGetStarted() {
  trackUnlimitedIntro('click', { button: 'got-it' })
  completeUnlimitedIntro()
  router.push({ name: 'closet-sections' })
}
</script>

<style lang="scss" scoped>
.unlimited-intro-modal {
  :deep(.modal-backdrop) {
    --bs-backdrop-opacity: 0.75;
    --bs-backdrop-bg: #{$armor};
  }

  :deep(.modal-content) {
    background-color: $origami;
  }

  :deep(.footer) {
    background: $origami;
    padding: $spacing-md !important;
    border: none;
  }
}
</style>

